import React from "react";
import { cliError } from "../../../helpers/cli/colors";
import { convertEditorStateToHTML, getPlainTextFromContent } from "../../../components/draftEditor/export/exports";
import TextPageLayout from "./TextPageLayout";
import Breadcrumb, { BreadcrumbLayer } from "../../../components/Breadcrumb";
import articleStyles from "./articleStyles.module.scss";
import DraftHTML from "../../../components/draftEditor/export/DraftHTML";

export function preparePageArticle({page, titleStyles, contentStyles}) {

    if (!page.page_title?.blocks?.some?.(b => !!b.text)) cliError(`No article title found for page ${page.url}`);
    if (!page.page_content?.blocks?.some?.(b => !!b.text)) cliError(`No article content found for page ${page.url}`);
    if (!page.page_title?.blocks?.some?.(b => !!b.text)) throw (`No article title found for page ${page.url}`);
    if (!page.page_content?.blocks?.some?.(b => !!b.text)) throw (`No article content found for page ${page.url}`);

    return {
        title: getPlainTextFromContent(page.page_title),
        page_title: convertEditorStateToHTML(page.page_title, {styles: titleStyles}),
        page_content: convertEditorStateToHTML(page.page_content, {styles: contentStyles}),
    };
}

export default function PageArticle({page, breadcrumb, className}) {

    return (
        <TextPageLayout
            breadcrumb={
                !breadcrumb
                    ?
                    <Breadcrumb inverse>
                        <BreadcrumbLayer link='/' name='Home'/>
                        <BreadcrumbLayer name={page.title}/>
                    </Breadcrumb>
                    :
                    breadcrumb
            }
            title={page.title}
        >
            <DraftHTML
                className={`content-editor ${articleStyles.article}${!!className ? ' ' + className : ''}`}
                content={page.page_content}
            />
        </TextPageLayout>
    )
}